import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.config.productionTip = false;

Vue.use(VueAxios, axios);

window.API_KEY = '53cd4a18-b11b-49c5-81d2-29c1b6a7cc5d';

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
